const TERMINAL_RUN_STATUSES = new Set([
  'completed',
  'complete',
  'finished',
  'cancelled',
  'canceled',
  'ended',
  'stopped',
]);

export const resolveRunScheduleId = (run) =>
  run?.scheduleId ??
  run?.schedule_id ??
  run?.scheduleID ??
  run?.schedule?.id ??
  run?.schedule_definition?.id ??
  run?.scheduleDefinition?.id ??
  run?.scheduleDefinitionId ??
  run?.schedule_definition_id ??
  run?.schedule_definitionId ??
  run?.definition?.id ??
  run?.definitionId ??
  run?.definition_id ??
  null;

export const resolveRunSchedule = (run) =>
  run?.schedule ?? run?.schedule_definition ?? run?.scheduleDefinition ?? run?.definition ?? null;

export const resolveRunScheduleName = (run) =>
  run?.schedule?.name ??
  run?.schedule_definition?.name ??
  run?.scheduleDefinition?.name ??
  run?.definition?.name ??
  run?.scheduleName ??
  run?.schedule_name ??
  null;

export const resolveRunScheduleColor = (run) =>
  run?.schedule?.color ??
  run?.schedule_definition?.color ??
  run?.scheduleDefinition?.color ??
  run?.definition?.color ??
  run?.scheduleColor ??
  run?.schedule_color ??
  run?.color ??
  null;

export const resolveRunStart = (run) =>
  run?.started_at ?? run?.startedAt ?? run?.start_time ?? run?.created_at ?? run?.createdAt ?? null;

export const resolveRunEnd = (run) =>
  run?.ended_at ?? run?.endedAt ?? run?.end_time ?? run?.ended_time ?? run?.endTime ?? null;

export const resolveRunUserId = (run) =>
  run?.userId ??
  run?.user_id ??
  run?.startedBy ??
  run?.started_by ??
  run?.personnelId ??
  run?.personnel_id ??
  null;

export const isRunOpen = (run) => {
  if (!run) return false;
  if (resolveRunEnd(run)) return false;
  const status = `${run?.status ?? run?.state ?? ''}`.toLowerCase();
  return !TERMINAL_RUN_STATUSES.has(status);
};

export const getRunStatusLabel = (run) => {
  if (!run) return 'No Activity';
  const status = `${run?.status ?? run?.state ?? ''}`.toLowerCase();
  if (status) return status.replace(/[_-]+/g, ' ');
  if (resolveRunEnd(run)) return 'completed';
  return 'active';
};
